// extracted by mini-css-extract-plugin
export var root = "a3b06a089b2f4049964384097d8e7ad8-css";
export var card = "e399f7d267784ca2c3288d04454621c4-css";